import { styled } from '@mui/material';

export const Header = styled('span')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '38px',
  lineHeight: '44px',
  letterSpacing: '-0.02em',
  marginBottom: theme.spacing(1),
  textAlign: 'center',
}));

export const SubHeader = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '18px',
  lineHeight: '24px',
  letterSpacing: '-0.02em',
  marginBottom: theme.spacing(8),
  textAlign: 'center',
}));
